export enum BidLeaderStatus {
  Leader,
  LeaderRisky,
  LeaderAuctionEnd,
  BestBid,
  NotLeader,
  NotLeaderAuctionEnd,
  Negotiations,
}
